import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { ChevronLeft, ChevronRight } from "lucide-react";

const h = (m) => `${Math.floor(m / 60)}j ${m % 60}m`;
const DAYS = ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"];

const Ranking = ({ rows }) => (
  <div className="overflow-x-auto mt-4">
    <table className="w-full text-xs" data-testid="fin-eff-table">
      <thead><tr className="text-left text-slate-500 border-b"><th className="py-1 pr-2">#</th><th className="pr-2">Anggota</th><th className="pr-2">Kerja</th><th className="pr-2">Istirahat/jeda</th><th className="pr-2">Efektif</th><th className="pr-2">Hari kerja</th><th>Lewat batas</th></tr></thead>
      <tbody>{rows.map((r, i) => (
        <tr key={r.email} className="border-b border-slate-50" data-testid={`fin-eff-row-${i}`}>
          <td className="py-1.5 pr-2 font-bold">{i + 1}</td><td className="pr-2">{r.name}</td><td className="pr-2">{h(r.work_min)}</td><td className="pr-2">{h(r.break_min)}</td>
          <td className={`pr-2 font-semibold ${r.eff_pct >= 85 ? "text-emerald-700" : r.eff_pct >= 70 ? "text-amber-700" : "text-rose-700"}`}>{r.eff_pct}%</td>
          <td className="pr-2">{r.active_days}</td><td className={r.over_days ? "text-rose-700 font-semibold" : ""}>{r.over_days ? `${r.over_days} hari` : "-"}</td>
        </tr>
      ))}</tbody>
    </table>
  </div>
);

const Daily = ({ r, days }) => (
  <div className="mt-3" data-testid={`fin-eff-daily-${r.email}`}>
    <div className="text-xs font-semibold mb-1">{r.name} · per hari</div>
    <div className="h-40"><ResponsiveContainer><BarChart data={r.days.map((d, i) => ({ day: DAYS[i], Kerja: +(d.work / 60).toFixed(1), Istirahat: +(d.break / 60).toFixed(1) }))}>
      <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" /><XAxis dataKey="day" fontSize={11} /><YAxis fontSize={11} unit="j" /><Tooltip />
      <Bar dataKey="Kerja" stackId="a" fill="#0f766e" /><Bar dataKey="Istirahat" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
    </BarChart></ResponsiveContainer></div>
  </div>
);

export const FinEffect = () => {
  const [wk, setWk] = useState(0); const [d, setD] = useState(null); const [sel, setSel] = useState("");
  useEffect(() => { api.get(`/finishing/effectiveness?week=${wk}`).then(({ data }) => setD(data)).catch(() => setD(null)); }, [wk]);
  if (!d) return null;
  const data = d.rows.map((r) => ({ name: r.name, Kerja: +(r.work_min / 60).toFixed(1), Istirahat: +(r.break_min / 60).toFixed(1) }));
  const one = d.rows.find((r) => r.email === sel);
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 mt-6" data-testid="fin-effect">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <div className="font-semibold">Rekap efektivitas tim mingguan</div>
        <div className="ml-auto flex items-center gap-1 text-xs">
          <button type="button" aria-label="minggu sebelumnya" data-testid="fin-eff-prev" onClick={() => setWk(wk - 1)} className="p-1 rounded hover:bg-slate-100"><ChevronLeft className="w-4 h-4" /></button>
          <span data-testid="fin-eff-week">{d.week_start} – {d.week_end}</span>
          <button type="button" aria-label="minggu berikutnya" data-testid="fin-eff-next" disabled={wk >= 0} onClick={() => setWk(wk + 1)} className="p-1 rounded hover:bg-slate-100 disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
        </div>
      </div>
      {!d.rows.length ? <p className="text-sm text-slate-400" data-testid="fin-eff-empty">Belum ada catatan kerja finishing minggu ini.</p> : <>
        <div className="h-64" data-testid="fin-eff-chart"><ResponsiveContainer><BarChart data={data} onClick={(e) => { const r = d.rows[e?.activeTooltipIndex]; if (r) setSel(r.email === sel ? "" : r.email); }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" /><XAxis dataKey="name" fontSize={11} interval={0} /><YAxis fontSize={11} unit="j" /><Tooltip /><Legend />
          <Bar dataKey="Kerja" stackId="a" fill="#0f766e" /><Bar dataKey="Istirahat" stackId="a" fill="#f59e0b" radius={[4, 4, 0, 0]} />
        </BarChart></ResponsiveContainer></div>
        <p className="text-[11px] text-slate-500">Istirahat = semua jeda antara mulai & selesai kerja (termasuk Lunch/Dinner/Pray/Toilet/Pause). Batas normal {d.break_free_min} mnt, maks {d.break_max_min} mnt per hari. Klik batang untuk lihat per hari.</p>
        {one && <Daily r={one} days={d.days} />}
        <Ranking rows={d.rows} />
      </>}
    </div>
  );
};
